import { IMapQCError } from '90.quickConnect.Models/mappings/errors/interfaces/IMapQCError';

export abstract class AbstractMapQCError<I, O> implements IMapQCError<I, O> {
  abstract mapFrom(param: I): O;
  abstract mapTo(param: O): I;
}
